<template>
  <section class="mdc-card-text mdc-card__supporting-text">
    <slot/>
  </section>
</template>

<script>
export default {
  name: 'mdc-card-text'
}
</script>
